// extracted by mini-css-extract-plugin
module.exports = {"container":"dragAndDrop_container__3kxkZ","buttonDiv":"dragAndDrop_buttonDiv__1Rv2R","apply":"dragAndDrop_apply__2VpqH"};